var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirdSquad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5137 21.6778C14.8841 21.6778 14.3026 21.5333 13.7693 21.2444C13.2433 20.9556 12.8211 20.5704 12.5026 20.0889L13.3693 18.3667C13.4359 18.7148 13.5693 19.0296 13.7693 19.3111C13.9767 19.5852 14.2322 19.8037 14.5359 19.9667C14.8396 20.1296 15.1693 20.2111 15.5248 20.2111C15.91 20.2111 16.2545 20.1222 16.5582 19.9444C16.8693 19.7667 17.1137 19.5259 17.2915 19.2222C17.4693 18.9185 17.5582 18.5778 17.5582 18.2C17.5582 17.8222 17.4693 17.4815 17.2915 17.1778C17.1137 16.8741 16.8693 16.6333 16.5582 16.4556C16.2545 16.2778 15.9026 16.1889 15.5026 16.1889C15.2952 16.1889 15.0952 16.2148 14.9026 16.2667C14.7174 16.3111 14.5396 16.3815 14.3693 16.4778L14.3582 16.4667L16.1915 12.9H13.2026V11.5H18.5359V11.5222L16.647 15.0222C16.9878 15.1185 17.3063 15.2667 17.6026 15.4667C17.9063 15.6593 18.1693 15.8963 18.3915 16.1778C18.6137 16.4519 18.7878 16.763 18.9137 17.1111C19.0396 17.4593 19.1026 17.8296 19.1026 18.2222C19.1026 18.7037 19.0063 19.1556 18.8137 19.5778C18.6285 20 18.3693 20.3667 18.0359 20.6778C17.71 20.9889 17.3322 21.2333 16.9026 21.4111C16.473 21.5889 16.01 21.6778 15.5137 21.6778Z",
    fill: "url(#paint0_linear_12734_12533)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2073 18.7092C30.7774 17.4254 31.1705 15.3088 31.0102 13.0393C30.6291 12.9726 29.8596 12.8182 29.4869 12.7802C30.8412 10.7108 30.2533 8.36584 28.8721 6.13281L27.946 6.42024C24.1174 7.55259 22.6721 10.9881 24.5902 14.4785C23.5462 15.6817 23.242 17.5191 23.3685 19.3596C22.5663 20.0753 21.918 21.2566 21.5191 22.4385C20.4307 22.748 19.4065 23.452 18.5032 24.5205C17.5599 24.4616 16.6556 24.7509 16.0224 25.4013C15.3886 24.7502 14.484 24.4616 13.5401 24.5205C12.6368 23.4521 11.6126 22.748 10.5243 22.4385C10.1252 21.2562 9.4774 20.0761 8.67483 19.3597C8.80153 17.5193 8.49686 15.681 7.45314 14.4786C9.37117 10.9879 7.92593 7.55283 4.09714 6.4203C4.0972 6.4203 3.17139 6.13287 3.17139 6.13287C1.78932 8.36631 1.20267 10.7118 2.55641 12.7803C2.18768 12.8176 1.40998 12.9735 1.03309 13.0394C0.872835 15.3099 1.26644 17.4259 2.83603 18.7092C2.34177 18.9358 1.64479 19.4019 1.17018 19.6996C1.88816 21.9199 3.08445 23.7608 5.10619 24.3261C4.91139 24.5376 4.40891 25.169 4.2178 25.4003L4.83008 26.1521C7.30144 29.2716 11.0168 29.3425 13.5401 26.2802H13.9C14.5851 26.2802 15.1424 26.8375 15.1424 27.5227V31.0007H16.9022V27.5227C16.9022 26.8376 17.4596 26.2802 18.1447 26.2802H18.5031C21.0265 29.3425 24.7416 29.2715 27.213 26.1521C27.213 26.1521 27.8255 25.4003 27.8255 25.4003C27.6312 25.1652 27.1347 24.5411 26.9369 24.3261C28.9595 23.7605 30.1552 21.9188 30.8731 19.6995C30.396 19.4003 29.7042 18.9372 29.2073 18.7092ZM4.02616 8.25756C6.36478 9.14747 7.13497 11.0621 6.06409 13.3236C3.78449 12.4821 2.93088 10.5094 4.02616 8.25756ZM2.77514 14.5264C5.25988 14.2313 6.82953 15.5715 6.92832 18.0716C4.54219 18.3685 2.86407 17.0865 2.77514 14.5264ZM3.3422 20.4261C5.45873 19.2408 7.50223 19.8505 8.52073 22.1583C6.41646 23.3266 4.38416 22.767 3.3422 20.4261ZM9.23848 26.7831C8.2936 26.7831 7.35682 26.3069 6.50826 25.4003C8.12818 23.6198 10.2545 23.5197 11.9688 25.4003C11.1201 26.3069 10.1834 26.7831 9.23848 26.7831ZM28.0895 17.3507C27.3382 18.0147 26.1556 18.2011 25.1151 18.0716C25.2138 15.5713 26.7836 14.2315 29.2682 14.5264C29.2114 15.7668 28.8081 16.7372 28.0895 17.3507ZM25.7154 10.2745C26.0681 9.39783 26.8594 8.70647 28.0173 8.25756C29.1125 10.5095 28.2588 12.4822 25.9794 13.3236C25.455 12.1979 25.3628 11.1511 25.7154 10.2745ZM22.8049 26.7831C21.8601 26.7831 20.9233 26.3069 20.0747 25.4003C21.7893 23.5193 23.9155 23.6202 25.5352 25.4003C24.6866 26.3069 23.7498 26.7831 22.8049 26.7831ZM26.5506 22.6036C25.621 22.9392 24.4289 22.6648 23.5228 22.1583C24.5412 19.8502 26.5849 19.241 28.7012 20.4261C28.184 21.5551 27.4466 22.3039 26.5506 22.6036Z",
    fill: "url(#paint1_linear_12734_12533)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2344 9.58104L16.0226 8.79284L18.8107 9.58104L18.9227 6.68581L20.5339 4.27769L17.8149 3.27655L16.0225 1L14.2301 3.2765L11.5112 4.27769L13.1224 6.68581L13.2344 9.58104ZM15.3051 4.75599L16.0225 3.84472L16.74 4.75599L17.8284 5.15675L17.1835 6.12069L17.1387 7.27967L16.0226 6.96415L14.9065 7.27967L14.8617 6.12069L14.2167 5.15675L15.3051 4.75599Z",
    fill: "url(#paint2_linear_12734_12533)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12734_12533",
    x1: 12.2417,
    y1: 11.4833,
    x2: 22.1484,
    y2: 21.1428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6947E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F6959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#F8DAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#AC836E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#B6947E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DCCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12734_12533",
    x1: 5.75686,
    y1: 9.65577,
    x2: 22.0087,
    y2: 34.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6947E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F6959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#F8DAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#AC836E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#B6947E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DCCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12734_12533",
    x1: 12.9398,
    y1: 2.21565,
    x2: 18.8051,
    y2: 9.86875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6947E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F6959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#F8DAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#AC836E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#B6947E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DCCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdSquad);
export default __webpack_public_path__ + "static/media/third_squad.9b8f414d8a6e6c3bf7880b71d97a4f02.svg";
export { ForwardRef as ReactComponent };